import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import variableStyles from '../../styles/variables.module.css.js';

const Variant12PathwayIllustration = /*#__PURE__*/ forwardRef(({ color = variableStyles.black, width = '100%' }, ref)=>jsx("svg", {
        width: width,
        viewBox: "0 0 826 1166",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: jsx("path", {
            ref: ref,
            d: "M70.0137 70.9453C172.678 125.673 279.274 191.033 355.088 281.01C401.595 336.228 434.521 406.503 430.5 478.609C424.38 588.958 336.414 677.683 309.162 784.771C277.755 908.12 332.661 1040.58 419.153 1133.95C515.116 1237.56 646.462 1291.57 755.068 1376.32",
            stroke: color,
            strokeWidth: "140",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
        })
    }));

export { Variant12PathwayIllustration as default };
